import React, { useState, useEffect, useContext } from 'react';
import { Paper, BottomNavigation, BottomNavigationAction, Box, useTheme } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import SportsRoundedIcon from '@mui/icons-material/SportsRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import { ActiveTeamContext } from '../../context/ActiveTeamContext';
import { useAuth } from '../../context/AuthContext';

const BottomNavBar = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const { activeTeamId } = useContext(ActiveTeamContext);
    const { user } = useAuth();
    const [value, setValue] = useState(location.pathname);

    useEffect(() => {
        setValue(location.pathname);
    }, [location.pathname]);

    const handleNavigation = (event, newValue) => {
        setValue(newValue);
        navigate(newValue);
    };

    const teamEntry = user?.teams?.find(t => t?.team_id?.toString() === activeTeamId?.toString()) || null;
    const activeTeamRoles = [];
    if (teamEntry) {
        if (teamEntry.rolle) activeTeamRoles.push(teamEntry.rolle);
        if (teamEntry.sekundaer_rolle) activeTeamRoles.push(...teamEntry.sekundaer_rolle.toString().split(',').map(s => s.trim()).filter(Boolean));
    }
    const isTrainer = user?.role === 'trainer' || user?.isAdmin || user?.role === 'super_admin' || activeTeamRoles.includes('trainer') || activeTeamRoles.includes('admin');
    const isStatistikwart = user?.role === 'statistikwart' || activeTeamRoles.includes('statistikwart') || user?.isAdmin || user?.role === 'super_admin';

    return (
        <Box sx={{ position: 'fixed', bottom: 20, left: 0, right: 0, zIndex: 1100, px: 2, display: 'flex', justifyContent: 'center' }}>
            <Paper
                elevation={0}
                sx={{
                    width: '100%',
                    maxWidth: 500,
                    borderRadius: '8px',
                    border: '1px solid',
                    borderColor: 'divider',
                    background: theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(20px)',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
                }}
            >
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={handleNavigation}
                    sx={{
                        height: 70,
                        bgcolor: 'transparent',
                        '& .MuiBottomNavigationAction-root': {
                            minWidth: 'auto',
                            color: 'text.secondary',
                            transition: 'all 0.2s',
                            '&.Mui-selected': {
                                color: 'primary.main',
                                '& .MuiBottomNavigationAction-label': {
                                    fontWeight: 800,
                                    fontSize: '0.65rem'
                                }
                            }
                        }
                    }}
                >
                    <BottomNavigationAction label="Home" value="/" icon={<HomeRoundedIcon />} />
                    <BottomNavigationAction
                        label="Team"
                        value={activeTeamId ? `/teams/${activeTeamId}/overview` : '/teams'}
                        icon={<GroupsRoundedIcon />}
                    />
                    <BottomNavigationAction label="Termine" value="/termine" icon={<CalendarMonthRoundedIcon />} />
                    {isTrainer && <BottomNavigationAction label="Coach" value="/teams" icon={<SportsRoundedIcon />} />}
                    {isStatistikwart && <BottomNavigationAction label="Statistik" value={activeTeamId ? `/teams/${activeTeamId}/statistics` : '/statistics'} icon={<BarChartRoundedIcon />} />}
                </BottomNavigation>
            </Paper>
        </Box>
    );
};

export default BottomNavBar;